<template>
    <div class="feature-chapter-base">
        <div class="container">
            <a-row class="inner">
                <a-col :sm="12">
                    <div class="content" id="play">
                        <div class="icon-set">
                            <feature-icon color="blue" class="question-icon">
                                <span class="h5mota"><b>1200</b></span><span>+</span>
                            </feature-icon>
                            <feature-icon color="green" icon="search" class="explore-icon"/>
                            <feature-icon color="yellow" icon="trophy" class="contest-icon"/>
                        </div>
                        <h2 style="color: rgb(37, 154, 243);">开始玩塔</h2>
                        <p><span>
                            超过 1200 座塔等你来挑战！<br/>
                            广场上的塔拥有多样的世界观，创新的游戏机制，展示各具风味的精彩故事。<br/>
                            你也可以体验完备的计分机制，参与排名并争夺榜单。
                        </span></p>
                        <a href="/play" target="_blank">
                            <p class="link">游戏列表 <a-icon type="right"></a-icon></p>
                        </a>
                    </div>
                </a-col>
                <a-col :sm="12">
                    <div class="content" id="social">
                        <div class="icon-set">
                            <feature-icon color="gold" icon="team" class="question-icon"/>
                            <feature-icon color="silver" icon="share-alt" class="question-icon"/>
                        </div>
                        <h2 style="color: rgb(183, 137, 43);">社区</h2>
                        <p><span>广场拥有非常活跃的玩家群体，并提供了各类社交功能，举办拆塔和造塔比赛。现在就参与进来，参与比赛，或者分享你对某座塔的看法</span></p>
                        <a href="/bbs">
                            <p class="link">前往论坛 <a-icon type="right"></a-icon></p>
                        </a>
                        <a href="https://jq.qq.com/?_wv=1027&k=nJMrECRy">
                            <p class="link">加入qq群 <a-icon type="right"></a-icon></p>
                        </a>
                    </div>
                </a-col>
            </a-row>
        </div>
    </div>
</template>

<script>
import FeatureIcon from './FeatureIcon.vue'

export default {
  components: { FeatureIcon },

}
</script>

<style lang="less">
.feature-chapter-base {
    .content {
        margin-top: 50px;
    }
    @media (max-width: 767px) {
        .content {
            margin-top: 80px;
        }
    }
    @media (min-width: 768px) {
        margin-top: -20px;
        .icon-set {
            margin-left: -13px;
            margin-top: -13px;
        }
        .inner > div {
            padding-left: 0;
            padding-right: 0;
            .content {
                padding-top: 17px;
                padding-bottom: 20px;
                padding-left: 50px;
                padding-right: 50px;
            }
            &:last-child .content {
                border-left: 2px solid white;
                margin-left: -1px;
            }
        }
    }
    @media (min-width: 768px) {
        text-align: left;
    }
    @media (max-width: 767px) {
        text-align: center;
    }
    .feature-icon-base:first-child {
        z-index: 2;
    }
    .feature-icon-base:nth-child(2) {
        z-index: 1;
    }
    .feature-icon-base:not(:first-child) {
        margin-left: -50px;
    }
    .question-icon {
        font-weight: 500;
    }
    .question-icon span:first-child {
        position: relative;
        right: -2px;
    }
    .question-icon span:last-child {
        font-size: 16px;
        position: relative;
        top: -13px;
    }
}
</style>